import "prebid.js/modules/ttdBidAdapter";

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";
import {TheTradeDeskAdUnit} from "header-bidding-base/modules/config/domain/bidders/theTradeDeskConfig";

export class TheTradeDeskBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<TheTradeDeskAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.THETRADEDESK);
    }
}
